@if (displayDetails) {
  <div class="grid-container full-height full v-pad">
    <div class="user-form-max-width">
      <h2>Details</h2>
      <div class="grid-x grid-margin-x">
        <div class="cell small-6 bold">
          Status: {{status}}
        </div>
        <div class="cell small-6 bold">
          Issued Date: {{issuedDate}}
        </div>
        @if (relatedChiefsOrderInstance) {
          <div class="cell small-12 bold">
            Chief's Order that resulted in most recent status: {{relatedChiefsOrderInstance.chiefsOrderNumber}}
          </div>
          <div class="cell small-12 bold">
            Date of most recent status change: {{mostRecentStatusChangeDate}}
          </div>
        }
        <div class="cell small-6">
          Delivery Status: {{letterDeliveryStatus}}
        </div>
        <div class="cell small-6">
          Date Delivered: {{letterDeliveryDate}}
        </div>
      </div>
      @if (this.userIsInternal) {
        <h2>All Related Letters</h2>
        <div>
          <ag-grid-angular class="data-grid  wide-ag-menu" [rowData]="allAssociatedLetters" [gridOptions]="gridOptions" aria-label="Co Details">
          </ag-grid-angular>
        </div>
      }
      <h2>Original Letter Content</h2>
      <div class="grid-x grid-margin-x">
        @if (isLoading$ | async) {
          <div class="cell large-12 text-center">
            Generating PDF Preview...
          </div>
        }
        @if (pdfAvailable) {
          <!-- PDF -->
		  <div class="cell large-12 text-center">
			  <ngx-extended-pdf-viewer [src]="pdfUrl" [textLayer]="true" [showAll]="true" [showToolbar]="false" (pdfLoaded)="onLoadComplete($event)" [pageViewMode]="'infinite-scroll'" class="display-block border-one-pixel-solid"></ngx-extended-pdf-viewer>
		  </div>
          <div class="cell large-12 text-left">
            <button (click)="download()" class="button hollow">
              Download <svg-icon icon="icon-download" class="light-blue"></svg-icon>
            </button>
            <a style="display:none" href="" target="_blank" #downloadLink rel="noopener noreferrer"></a>
          </div>
        }
        @if (showError) {
          <div class="cell large-12 text-center">
            Unable to render the PDF.
          </div>
        }
      </div>
      @if (this.userIsInternal) {
        <div class="grid-x grid-margin-x">
          <div class="cell small-12">
            <upload-view-files [coInstanceId]="coInstanceId" [isPadded]="false" (newFilesList)="savedFiles($event)"></upload-view-files>
          </div>
          @if (hasFileListing()) {
            <div class="file-list cell small-12">
              Uploaded Files:
              <div class="margin-bottom">
                @for (fl of filesToShow; track fl) {
                  <div class="uploaded-files">
                    <span class="file-name padding-left">{{fl.fileName}}</span>
                    @if (allowFileDeletion(fl)) {
                      <button type="button" class="minor-margin-right" attr.aria-label="Delete file'{{fl.fileName}}'"
                        (click)="deleteFile(fl)">
                        <svg-icon class="dark-gray" aria-hidden="true" icon="icon-trash"></svg-icon>
                      </button>
                    }
                    <button type="button" attr.aria-label="Download file'{{fl.fileName}}'" class="btn btn-success btn-xs" (click)="downloadFile(fl)">
                      <svg-icon title="Download File" icon="icon-download" class="dark-gray" aria-hidden="true"></svg-icon>
                    </button>
                  </div>
                }
              </div>
              <div class="cell small-12">
                <button class="button hollow" (click)="sendToOnBase()" [disabled]="!canSendToOnbase()">Upload new attachments to Onbase</button>
              </div>
            </div>
          }
          <div class="cell small-12">
            <label for="notesText">{{notesDisplayHeader}}</label>
            <textarea id="notesText" [(ngModel)]="notesText" placeholder="Review Note"></textarea>
          </div>
          <div class="cell small-12">
            <div class="checkbox display-inline-block">
              <label class="inline">
                <input type="checkbox" [(ngModel)]="isInternalVal" [checked]="isInternalVal">
                Make Review Note Internal
              </label>
            </div>
          </div>
          @if (!displayManualStatusChangeDetails) {
            <div class="cell small-12">
              <button class="button hollow" (click)="addReviewNote()" [disabled]="notesText===''">Add Note</button>
            </div>
          }
        </div>
        @if (userCanManuallyChangeStatus) {
          <div class="cell large-12 text-left">
            <button (click)="toggleDisplayOfManualStatusChangeDetails()" class="button hollow" [disabled]="!isCurrentlyIssued()">
              {{manualStatusChangeButtonText}}
            </button>
          </div>
          @if (displayManualStatusChangeDetails) {
            <h2>Manually Set Chiefs Order Status:</h2>
            When manually changing the status of a chief's order, a note MUST to be provided. Anything entered into the Modification Reason text area will be submitted when you confirm this change. Any supporting documentation for this change can be uploaded as supplemental files.
            <div class="grid-x grid-margin-x">
              <div class="cell small-6">
                <ng-select [(ngModel)]="manualStatusToSet" [items]="validStatusesForManualStatusSet" placeholder=""></ng-select>
              </div>
              <div class="cell small-6">
                <button class="button hollow" (click)="toggleManuallyChangeStatusDialog()" [disabled]="notesText==='' || manualStatusToSet===''">Confirm Status Change</button>
              </div>
            </div>
          }
        }
        @if (canPerformAtleastOnePostIssueAction() && !displayManualStatusChangeDetails) {
          <div>
            <h2>Post Issue Actions:</h2>
            <div class="grid-x grid-margin-x">
              @if (canPerformPostIssueAction(postIssueOptions.Appeal)) {
                <div class="cell small-2 form-button-group">
                  <button class="button hollow minor-margin-right" (click)="kickOffAppeal()" [disabled]="!isCurrentlyIssued()">Appeal</button>
                </div>
              }
              @if (canPerformPostIssueAction(postIssueOptions.Modify)) {
                <div class="cell small-2 form-button-group">
                  <button class="button hollow minor-margin-right" (click)="kickOffNonAppealPostIssueAction(postIssueOptions.Modify)" [disabled]="!isCurrentlyIssued()">Modify</button>
                </div>
              }
              @if (canPerformPostIssueAction(postIssueOptions.Revoke)) {
                <div class="cell small-2 form-button-group">
                  <button class="button hollow minor-margin-right" (click)="kickOffNonAppealPostIssueAction(postIssueOptions.Revoke)" [disabled]="!isCurrentlyIssued()">Revoke</button>
                </div>
              }
              @if (canPerformPostIssueAction(postIssueOptions.Suspend)) {
                <div class="cell small-2 form-button-group">
                  <button class="button hollow minor-margin-right" (click)="kickOffNonAppealPostIssueAction(postIssueOptions.Suspend)" [disabled]="!isCurrentlyIssued()">Suspend</button>
                </div>
              }
              @if (canPerformPostIssueAction(postIssueOptions.Vacate)) {
                <div class="cell small-2 form-button-group">
                  <button class="button hollow minor-margin-right" (click)="kickOffNonAppealPostIssueAction(postIssueOptions.Vacate)" [disabled]="!isCurrentlyIssued()">Vacate</button>
                </div>
              }
              @if (canPerformPostIssueAction(postIssueOptions.Terminate)) {
                <div class="cell small-2 form-button-group">
                  <button class="button hollow minor-margin-right" (click)="kickOffNonAppealPostIssueAction(postIssueOptions.Terminate)" [disabled]="!isCurrentlyIssued()">Terminate</button>
                </div>
              }
            </div>
          </div>
        }
        @if (!canPerformAtleastOnePostIssueAction()) {
          <div>
            <h2>No Post Issue Actions can be taken.</h2>
            @if (aBlockingExistingPostIssueActionExists()) {
              <div>
                A Post-Issue Action is already in progress for the current Chief's Order.
              </div>
            }
          </div>
        }
      }
    </div>
  </div>
}
@if (!displayDetails && this.userIsInternal) {
  <h2>Please Choose the template you wish to use to kick off the {{this.selectedChiefOrderPostIssueOptionPrettyText}} of the Chief's Order #{{this.chiefsOrderInstance.chiefsOrderNumber}}:</h2>
  <ng-select [(ngModel)]="postIssueActionReport" [items]="filteredChiefsOrderTemplates" bindLabel="name" placeholder=""></ng-select>
  <div>
    <div class="grid-x grid-margin-x">
      <div class="cell small-6 form-button-group">
        <button class="button hollow minor-margin-right" [disabled]="postIssueActionReport===''" (click)="kickOffPostIssueAction()">Kick Off Post Issue Action</button>
      </div>
      <div class="cell small-6 form-button-group">
        <button class="button hollow minor-margin-right" (click)="cancelPostIssueAction()">Cancel</button>
      </div>
    </div>
  </div>
}